import React, { useState, useEffect } from 'react';
import {
    Card, CardContent, Button, Select, Box, Typography, Container, TextField,
    Radio, Grid, RadioGroup, FormLabel, FormControlLabel, Divider, FormControl,
    InputLabel, MenuItem, FormHelperText, DialogActions, DialogContent, Dialog,
    DialogTitle, InputAdornment, Checkbox, Autocomplete, ToggleButton, ToggleButtonGroup, Link
} from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import dayjs from 'dayjs';

import { allowedFileTypes, FILE_NAME_VALIDATION_ERROR, PIT_ROLES, PROD } from '../../../common/constants';

import { loaderService } from "../../../common/custom-loader/loader-service";
import { toast } from 'react-toastify';
import {
    authKey,
    CALCULATE_TOTAL_INVOICE_BY_GRN_LIST,
    DOWNLOAD_DOCUMENT,
    GENERATE_INVOICE,
    GENERATE_SES,
    GET_APPROVED_STAKEHOLDERS,
    GET_GRN_LIST_BY_SERVICE_PO,
    GET_INVOICE_NUMBER_LIST_FOR_SES,
    GET_MANUAL_PO_LIST,
    GET_PO_LIST_FOR_INVOICE,
    UPLOAD_DCUMENT
} from '../../../common/URLs';
import { getLocalStorageItem } from '../../../common/localStorageUtils';
import CustomDataGridToolbar from '../../../common/customDataGridToolbar';
import { DataGrid } from '@mui/x-data-grid';
import { useNavigate } from "react-router-dom";
import moment from 'moment';
import { capitalizeFunction, fileNameValidation, VALIDATION } from '../../../common/commonValidations';
import { ConfirmationPopover } from '../../../common/commonPopovers/confirmationPopover';
import { FileUploadMUI } from '../../../common/fileUpload/fileUploadMUI';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import apiClient from '../../../axios';
import { getAllRoutes } from '../../../resource/screens/transporterStakeHolderMappping/transportermappingApi';
import TrashIcon from '../../../images/TrashIcon.png';
import { t } from 'i18next';
import { Badge } from 'react-bootstrap';

function GenerateInvoice() {

    const navigate = useNavigate();
    const URN = localStorage.getItem('urn');
    const StakeholderCategory = localStorage.getItem('stakeholderCategory');
    const [routerDetails, setRouterDetails] = useState([]);
    const [characterLimit] = useState(16);
    const [details, setDetails] = useState({
        stakeholderType: URN ? StakeholderCategory : "",
        stakeholderUrn: URN ? URN : "",
        serviceStakeholderType: "",
        poNumber: "",
        comment: "",
        invoice: "yes",
        invoiceRequired: "no",
        invoiceNumber: "",
        invoiceDate: null,
        transMappingRoute: ''
    });

    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);

    const [errorMessage, setErrorMessage] = useState({
        stakeholderType: "",
        stakeholderUrn: "",
        serviceStakeholderType: "",
        poNumber: "",
        comment: "",
        invoice: "",
        invoiceRequired: "",
        invoiceNumber: "",
        invoiceDate: "",
        invoiceFile: ""
    });

    const [poList, setPoList] = useState([]);
    const [urnList, setUrnList] = useState([]);
    const [grnList, setGrnList] = useState([]);
    const [invoiceList, setInvoiceList] = useState([]);
    const [selectedInvoiceGridData, setSelectedInvoiceGridData] = useState([]);
    const [fetchedInvoiceDocs, setFetchedInvoiceDocs] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectionModel, setSelectionModel] = useState([]);
    const [proceed, setProceed] = useState(false);
    const [isChecked, setIsChecked] = useState(false);

    const [logModalOpen, setLogModalOpen] = useState(false);
    const handleLogModalOpen = () => setLogModalOpen(true);
    const handleLogModalClose = () => setLogModalOpen(false);

    const [isApiCalled, setIsApiCalled] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    const [documentUploadDetails, setDocumentUploadDetails] = useState();
    const [documentsArr, setDocumentsArr] = useState([]);
    const [selectedFile, setSelectedFile] = useState();
    const [fileuploadError, setFileuploadError] = useState('');

    const [totalDeliveredQty, setTotalDeliveredQty] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);
    const [gstData, setGstData] = useState();

    // View & Download Helper Function
    const viewdownloadDocument = (documentBlobName, finalfileName, type) => {
        loaderService.showLoader();
        return fetch(DOWNLOAD_DOCUMENT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                AuthKey: authKey,
            },
            body: JSON.stringify({
                "fileName": documentBlobName,
                "containerName": "pit",
                "file": ""
            })
        })
            .then((response) => response.blob())
            .then((blob) => {
                if (type === "View") {
                    const fileName = finalfileName || "";
                    const splittedName = fileName.split('.');
                    const fileExtension = splittedName[splittedName.length - 1]?.toLowerCase();
                    let fileType;
                    switch (fileExtension) {
                        case 'pdf':
                            fileType = 'application/pdf';
                            break;
                        case 'png':
                            fileType = 'image/png';
                            break;
                        case 'jpg':
                        case 'jpeg':
                            fileType = 'image/jpeg';
                            break;
                        default:
                            fileType = 'application/octet-stream';
                    }
                    const url = window.URL.createObjectURL(new Blob([blob], { type: fileType }));
                    const newWindow = window.open(url, '_blank');
                    if (newWindow) newWindow.focus();
                }
                else {
                    const a = document.createElement("a");
                    a.style.display = "none";
                    document.body.appendChild(a);
                    const url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = finalfileName;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
            });
    };

    const invoiceDetailsColumns = [
        { field: 'invoiceNumber', headerName: "Invoice Number", width: 140 },
        { field: 'weight', headerName: "Total Qty(MT)", width: 130 },
        { field: 'invoiceAmount', headerName: "Invoice Amount", width: 140 },
        { field: 'cgstTax', headerName: "CGST", width: 100 },
        { field: 'sgstTax', headerName: "SGST", width: 100 },
        { field: 'igstTax', headerName: "IGST", width: 100 },
        { field: 'invoiceTax', headerName: "Total Tax", width: 110 },
        { field: 'tdsTax', headerName: "TDS Tax", width: 110 },
        { field: 'totalInvoiceAmount', headerName: "Total Invoice Amount", width: 160 },
        { field: 'netAmountPayable', headerName: 'Net Amount Payable', width: 160},
        { field: 'invoiceAmount', headerName: "Invoice Amount", width: 110 },
        {
            field: 'invoiceDocuments',
            headerName: "Invoice Documents",
            width: 260,
            renderCell: (params) => {
                const docs = params.value || [];
                if (!docs || docs.length === 0) return <Typography variant="caption">No Documents</Typography>;
                return (
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, py: 0.5 }}>
                        {docs.map((doc, idx) => (
                            <Box key={doc.invoiceFileId || idx} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Link
                                    component="button"
                                    variant="body2"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        viewdownloadDocument(doc?.invoiceFileId, doc?.invoiceFileName, "View");
                                    }}
                                    underline="hover"
                                    sx={{ cursor: 'pointer', fontSize: '0.8rem' }}
                                >
                                    {doc.invoiceFileName}
                                </Link>
                                <Button
                                    size="small"
                                    variant="text"
                                    onClick={() => viewdownloadDocument(doc?.invoiceFileId, doc?.invoiceFileName, "Download")}
                                    sx={{ minWidth: 'auto', p: 0, fontSize: '0.7rem', textTransform: 'none' }}
                                >
                                    Download
                                </Button>
                            </Box>
                        ))}
                    </Box>
                );
            }
        }
    ];

    const calculateTotalInvoice = (rowsToCalculate) => {
        if (!rowsToCalculate || rowsToCalculate.length === 0) {
            setTotalDeliveredQty(0);
            setTotalAmount(0);
            return;
        }

        const payload = {
            servicePONumber: details.poNumber,
            totalInvoiceByGrnDetails: rowsToCalculate.map((row) => {
                const isDispatched = row?.isDispatchedQuantitySelected ?? false;
                return {
                    grnNumber: row.grnNo || row.grnNumber || "",
                    toleranceLimitValue: row.toleranceLimitValue || 0,
                    isWithInToleranceLimit: row.isWithInToleranceLimit ?? true,
                    isDispatchedQuantitySelected: isDispatched,
                    selectedQuantityType: isDispatched ? "DispatchedQuantity" : "GrnQuantity",
                    quantity: isDispatched ? (row.dispatchedQuantity || 0) : (row.grnQuantity || 0)
                };
            })
        };

        apiClient.post(CALCULATE_TOTAL_INVOICE_BY_GRN_LIST, payload, {
            headers: {
                Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                "Content-Type": "application/json"
            }
        })
            .then((response) => {
                if (response?.data?.isSuccess) {
                    setTotalDeliveredQty(response.data.totalQuantity ?? 0);
                    setTotalAmount(response.data.totalAmount ?? 0);
                    setGstData(response.data);

                    const updatedGrnDataList = response.data.grnList || [];

                    if (updatedGrnDataList.length > 0) {
                        setGrnList((prevGrnList) =>
                            prevGrnList.map((row) => {
                                const matchedData = updatedGrnDataList.find(
                                    (updatedRow) => updatedRow.grnNumber === (row.grnNo || row.grnNumber)
                                );
                                if (matchedData) {
                                    return {
                                        ...row,
                                        amount: matchedData.amount,
                                        cgstTax: matchedData.cgstTax,
                                        sgstTax: matchedData.sgstTax,
                                        igstTax: matchedData.igstTax,
                                        tax: matchedData.tax,
                                        totalAmount: matchedData.totalAmount
                                    };
                                }
                                return row;
                            })
                        );

                        setSelectedRows((prevSelected) =>
                            prevSelected.map((row) => {
                                const matchedData = updatedGrnDataList.find(
                                    (updatedRow) => updatedRow.grnNumber === (row.grnNo || row.grnNumber)
                                );
                                if (matchedData) {
                                    return {
                                        ...row,
                                        amount: matchedData.amount,
                                        cgstTax: matchedData.cgstTax,
                                        sgstTax: matchedData.sgstTax,
                                        igstTax: matchedData.igstTax,
                                        tax: matchedData.tax,
                                        totalAmount: matchedData.totalAmount
                                    };
                                }
                                return row;
                            })
                        );
                    }

                } else {
                    toast.error(response?.data?.message || "Calculation failed");
                }
            })
            .catch((error) => {
                toast.error(error.message || "Error calculating total invoice");
            });
    };

    const handleQtyToggleChange = (grnNo, newSelection) => {
        const isDispatched = newSelection === 'Dispatched';

        setGrnList((prevGrnList) => {
            const updatedList = prevGrnList.map((item) => {
                if (item.grnNo === grnNo) {
                    return { ...item, isDispatchedQuantitySelected: isDispatched };
                }
                return item;
            });

            setSelectedRows((prevSelected) => {
                const updatedSelected = prevSelected.map((item) => {
                    if (item.grnNo === grnNo) {
                        return { ...item, isDispatchedQuantitySelected: isDispatched };
                    }
                    return item;
                });

                if (updatedSelected.some((row) => row.grnNo === grnNo)) {
                    calculateTotalInvoice(updatedSelected);
                }
                return updatedSelected;
            });

            return updatedList;
        });
    };

    const grnColumns = [
        { field: 'consignmentNo', headerName: "Consignment Number", width: 170 },
        { field: 'stakeholderName', headerName: "Stakeholder Name", width: 150 },
        { field: 'stakeholderUrn', headerName: "Stakeholder Urn", width: 150 },
        { field: 'vehicleRegNo', headerName: "Vehicle Number", width: 150 },
        { field: 'materialType', headerName: "Material Type", width: 130 },
        { field: 'deliveryLocation', headerName: "Delivery Location", width: 150 },
        {
            field: 'dispatchedDate', headerName: "Dispatched Date", width: 120,
            valueFormatter: params => params?.value && moment(params?.value).format("DD/MM/YYYY"),
        },
        { field: 'distanceTravelled', headerName: "Distance Travelled(in KM)", width: 190 },
        { field: 'deliveryChallanNo', headerName: "Delivery Challan Number", width: 180 },
        { field: 'dispatchedQuantity', headerName: "Dispatch Quantity(in MT)", width: 150 },
        {
            field: 'grnQuantity',
            headerName: "GRN Quantity(in MT)",
            width: 150,
            renderCell: (params) => {
                const isHighlighted = !URN && params?.row?.isWithInToleranceLimit === false;
                return (
                    <Box
                        sx={{
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            ...(isHighlighted && {
                                backgroundColor: 'rgba(255, 0, 0, 0.12)',
                                color: 'error.main',
                                fontWeight: 'bold',
                                px: 1,
                                borderRadius: '4px'
                            })
                        }}
                    >
                        {params.value}
                    </Box>
                );
            }
        },
        { field: 'toleranceLimitValue', headerName: "Tolerance", width: 150 },
        { field: 'devaitionweightPer', headerName: "Deviation Weight %", width: 150 },
        { field: 'rate', headerName: "Rate(in INR)", width: 150 },
        { field: 'amount', headerName: "Amount(in INR)", width: 150 },
        { field: 'cgstTax', headerName: t('pit.cgst'), width: 100 },
        { field: 'sgstTax', headerName: t('pit.sgst'), width: 100 },
        { field: 'igstTax', headerName: t('pit.igst'), width: 100 },
        { field: 'tdsTax', headerName: 'TDS Tax (INR)', width: 100 },
        { field: 'tax', headerName: 'Total Tax', width: 150 },
        {
            field: 'totalAmount',
            headerName: 'Total Invoice Amount (Inc. Taxes) (INR)',
            width: 210
        },
        {
            field: 'qty',
            headerName: "Qty considered for Invoicing",
            width: 220,
            renderCell: (params) => {
                const isDispatched = params?.row?.isDispatchedQuantitySelected ?? false;

                const isSelected = selectionModel.some(
                    (id) => id.toString() === (params.row.grnNo?.toString() || params.row.grnNumber?.toString())
                );

                return (
                    <ToggleButtonGroup
                        value={isDispatched ? 'Dispatched' : 'GRN'}
                        exclusive
                        disabled={!URN || !isSelected}
                        size="small"
                        onClick={(e) => e.stopPropagation()}
                        onChange={(e, newSelection) => {
                            if (newSelection !== null) {
                                handleQtyToggleChange(params.row.grnNo, newSelection);
                            }
                        }}
                    >
                        <ToggleButton value="GRN" sx={{ px: 1, py: 0.2, fontSize: '0.75rem' }}>
                            GRN
                        </ToggleButton>
                        <ToggleButton value="Dispatched" sx={{ px: 1, py: 0.2, fontSize: '0.75rem' }}>
                            Dispatch
                        </ToggleButton>
                    </ToggleButtonGroup>
                );
            }
        },
    ];

    useEffect(() => {
        if (!URN && details.invoiceRequired === 'no') {
            setIsChecked(false);
        } else {
            setIsChecked(details.invoice === 'no');
        }
    }, [details.invoice, details.invoiceRequired, URN]);

    const handleChange = (e, tempProceed) => {
        tempProceed && setProceed(false);

        if (e.target.name === "invoiceNumber") {
            const selectedVal = e.target.value ? e.target.value.toUpperCase() : "";
            setDetails({ ...details, [e.target.name]: selectedVal });
            setErrorMessage({ ...errorMessage, [e.target.name]: "" });

            const selectedObj = invoiceList.find((item) =>
                (typeof item === 'object' ? item.invoiceNumber : item) === selectedVal
            );

            if (selectedObj && typeof selectedObj === 'object') {
                setSelectedInvoiceGridData([selectedObj]);
                setFetchedInvoiceDocs(selectedObj.invoiceDocuments || []);
            } else {
                setSelectedInvoiceGridData([]);
                setFetchedInvoiceDocs([]);
            }
        }
        else if (e.target.name === "invoiceRequired") {
            setDetails({
                ...details,
                [e.target.name]: e.target.value,
                invoiceNumber: "",
                invoiceDate: null
            });
            if (e.target.value === "no") {
                setFromDate(null);
                setToDate(null);
            }
            setErrorMessage({
                ...errorMessage,
                [e.target.name]: "",
                invoiceNumber: ""
            });
            setSelectedInvoiceGridData([]);
            setFetchedInvoiceDocs([]);
        }
        else {
            setDetails({ ...details, [e.target.name]: e.target.value });
            setErrorMessage({ ...errorMessage, [e.target.name]: "" });
        }

        if (e.target.name === "stakeholderType") {
            getUrnList(e.target.value);
        }
        if (e.target.name === "poNumber") {
            getInvoiceList(e.target.value);
        }
    };

    const onProceed = () => {
        if (!URN) {
            if (!details.stakeholderType) {
                setErrorMessage({ ...errorMessage, stakeholderType: "Please select stakeholder type" });
            }
            else if (!searchTerm) {
                setErrorMessage({ ...errorMessage, stakeholderUrn: "Please select stakeholder urn" });
            }
            else if (details.stakeholderType === "HIT" && !details.serviceStakeholderType) {
                setErrorMessage({ ...errorMessage, serviceStakeholderType: "Please select service stakeholder type" });
            }
            else if (!details.poNumber) {
                setErrorMessage({ ...errorMessage, poNumber: "Please select po number" });
            }
            else if (details.invoiceRequired === "no" && !details.invoiceNumber) {
                setErrorMessage({ ...errorMessage, invoiceNumber: "Please select invoice number" });
            }
            else {
                setProceed(true);
                getGrnList();
            }
        }
        else {
            setProceed(true);
            getGrnList();
        }
    };

     const onCreateInvoice = () => {
        const isScmNoInvoice = !URN && details?.invoiceRequired === "no";
        const needsRowSelection = URN || details?.invoiceRequired === "yes";
        const isUploadInvoiceYes = details?.invoice === "yes";

        if (needsRowSelection && selectedRows.length === 0) {
            toast.error("Select at least one row");
        }
        else if (needsRowSelection && isUploadInvoiceYes && !details.invoiceNumber) {
            setErrorMessage({ ...errorMessage, invoiceNumber: "Please enter invoice number" });
        }
        else if (needsRowSelection && isUploadInvoiceYes && !details.invoiceDate) {
            setErrorMessage({ ...errorMessage, invoiceDate: "Please select invoice date" });
        }
        else if (needsRowSelection && isUploadInvoiceYes && documentsArr.length === 0) {
            setFileuploadError("Please upload at least one invoice document");
        }
        else if (!details.comment) {
            setErrorMessage({ ...errorMessage, comment: "Please enter comment" });
        }
        else {
            setErrorMessage({ ...errorMessage, invoiceNumber: "", invoiceDate: "", comment: "" });
            setFileuploadError("");
            handleLogModalOpen();
        }
    };

    const onConfirmSubmit = async () => {
        if (isApiCalled) return;
        setIsApiCalled(true);
        try {
            await GenerateInvoiceSubmit();
            await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
            console.error("API failed:", error);
        } finally {
            setLogModalOpen(false);
            setIsApiCalled(false);
        }
    };

    const getUrnList = (stakeholderTypeValue) => {
        loaderService.showLoader();
        apiClient.post(GET_APPROVED_STAKEHOLDERS,
            {
                "type": stakeholderTypeValue
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                setUrnList(response.data.stakeHolders);
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };

    useEffect(() => {
        getAllRoutes(setRouterDetails);
    }, [URN]);

    useEffect(() => {
        const activeUrn = URN || searchTerm;

        if (!activeUrn || !details.stakeholderType) {
            return; 
        }

        let isReadyToFetch = false;

        if (details.stakeholderType === "HIT") {
            if (details.serviceStakeholderType) {
                isReadyToFetch = true;
            }
        } else if (details.stakeholderType === "Transporter") {
            isReadyToFetch = true;
        }

        if (isReadyToFetch) {
            getPoList(activeUrn);

            if (!URN) {
                setDetails((prev) => ({
                    ...prev,
                    poNumber: "",
                    invoiceNumber: "",
                    invoiceDate: null
                }));
            }
        }

    }, [
        URN, 
        searchTerm, 
        details.stakeholderType, 
        details.serviceStakeholderType, 
        details.transMappingRoute 
    ]);

        const getPoList = (activeUrn) => {
        loaderService.showLoader();
        apiClient.post(GET_PO_LIST_FOR_INVOICE,
            {
                "stakeholderType": details.stakeholderType,
                "stakeholderUrn": activeUrn, 
                "serviceStakeholderType": details?.stakeholderType === "Transporter" ? "Transporter" : details.serviceStakeholderType,
                "routeType": details?.transMappingRoute
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                setPoList(response.data.poNumberList);
                loaderService.hideLoader();
            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };

    const getInvoiceList = (poValue) => {
        loaderService.showLoader();
        apiClient.post(GET_INVOICE_NUMBER_LIST_FOR_SES,
            {
                "stakeholderType": details.stakeholderType,
                "stakeholderUrn": searchTerm,
                "serviceStakeholderType": details?.stakeholderType === "Transporter" ? "Transporter" : details.serviceStakeholderType,
                "servicePoNumber": poValue,
                "isSesCreated": false
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                const list = response?.data?.invoiceNumberList || [];
                setInvoiceList(list);
                setSelectedInvoiceGridData([]);
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };

    const getGrnList = () => {
        loaderService.showLoader();
        const isInvoiceReqNo = details?.invoiceRequired === "no";

        apiClient.post(GET_GRN_LIST_BY_SERVICE_PO,
            {
                "servicePONumber": details.poNumber,
                "invoiceNumber": isInvoiceReqNo ? details.invoiceNumber : "",
                "isNeedtoGeneratedInvoice": (URN || details?.invoiceRequired === "yes") ? true : false,
                "serviceStakeholderType": details?.stakeholderType === "Transporter" ? "Transporter" : details.serviceStakeholderType,
                "isSesCreated": false,
                "dispatchedFromDate": ((URN || !isInvoiceReqNo) && fromDate) ? fromDate.format('YYYY-MM-DD') : "",
                "dispatchedToDate": ((URN || !isInvoiceReqNo) && toDate) ? toDate.format('YYYY-MM-DD') : ""
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                const list = response?.data?.grnDetailsList ? response?.data?.grnDetailsList : [];
                const formattedList = list.map(item => ({
                    ...item,
                    isDispatchedQuantitySelected: item.isDispatchedQuantitySelected ?? false
                }));
                setGrnList(formattedList);

                if (response?.data?.invoiceDocuments) {
                    setFetchedInvoiceDocs(response.data.invoiceDocuments);
                }

                setSelectionModel([]);
                setSelectedRows([]);
                setTotalDeliveredQty(0);
                setTotalAmount(0);
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };

    const GenerateInvoiceSubmit = () => {
        loaderService.showLoader();

        const targetRows = (details?.invoiceRequired === "no" && !URN) ? grnList : selectedRows;
        const selectedMaterialtype = targetRows[0]?.materialType || '';
        const selectedInvObj = selectedInvoiceGridData?.[0] || {};
        const isNoInvoiceReq = !URN && details?.invoiceRequired === "no";

        let docListPayload = [];
        if (isNoInvoiceReq) {
            const docsToUse = fetchedInvoiceDocs?.length > 0 ? fetchedInvoiceDocs : (selectedInvObj?.invoiceDocuments || []);
            docListPayload = docsToUse?.map(doc => ({
                "invoiceFileId": doc?.invoiceFileId || doc?.blobFileName || "",
                "invoiceFileName": doc?.invoiceFileName || doc?.fileName || "",
                "containerName": doc?.containerName || "pit"
            })) || [];
        } else if (details.invoice === "yes") {
            docListPayload = documentsArr?.map(doc => ({
                "invoiceFileId": doc?.blobFileName || "",
                "invoiceFileName": doc?.fileName || "",
                "containerName": "pit"
            })) || [];
        }

        const payload = {
            "stakeholderType": details.stakeholderType || "",
            "stakeholderUrn": URN ? URN : searchTerm,
            "servicePOnumber": details.poNumber || "",
            "serviceStakeholderType": details?.stakeholderType === "Transporter" ? "Transporter" : details.serviceStakeholderType,
            "roleName": localStorage.getItem('role') || "",
            "userName": localStorage.getItem('userName') || "",
            "isInvoiceNoUploaded": (!URN && details?.invoiceRequired === "no") ? false : (details.invoice === "yes"),
            "uploadedInvoiceNumber": details.invoice === "yes" ? details.invoiceNumber : "",
            "comment": details.comment || "",
            "isNeedtoGeneratedInvoice": isChecked,
            "selectedInvoiceNumber": details?.invoiceRequired === "no" ? details.invoiceNumber : "",
            "grnNoList": targetRows?.map(item => item.grnNo || item.grnNumber || ""),
            "totalInvoiceByGrnDetails": targetRows?.map(row => {
                const isDispatched = row?.isDispatchedQuantitySelected ?? false;
                return {
                    "grnNumber": row.grnNo || row.grnNumber || "",
                    "toleranceLimitValue": row.toleranceLimitValue || 0,
                    "isWithInToleranceLimit": row.isWithInToleranceLimit ?? true,
                    "isDispatchedQuantitySelected": isDispatched,
                    "selectedQuantityType": isDispatched ? "DispatchedQuantity" : "GrnQuantity",
                    "quantity": isDispatched ? (row.dispatchedQuantity || 0) : (row.grnQuantity || 0)
                };
            }),
            "uploadedHarvesterInvoiceNumber": "",
            "invoiceDate": details.invoice === "yes" && details.invoiceDate ? details.invoiceDate.format('YYYY-MM-DD') : "",
            "isGenerateSes": !URN,
            "amount": isNoInvoiceReq ? (selectedInvObj?.invoiceAmount ?? gstData?.amount ?? 0) : (gstData?.amount ?? 0),
            "cgstTax": isNoInvoiceReq ? (selectedInvObj?.cgstTax ?? gstData?.cgstTax ?? 0) : (gstData?.cgstTax ?? 0),
            "sgstTax": isNoInvoiceReq ? (selectedInvObj?.sgstTax ?? gstData?.sgstTax ?? 0) : (gstData?.sgstTax ?? 0),
            "igstTax": isNoInvoiceReq ? (selectedInvObj?.igstTax ?? gstData?.igstTax ?? 0) : (gstData?.igstTax ?? 0),
            "tax": isNoInvoiceReq ? (selectedInvObj?.invoiceTax ?? selectedInvObj?.tax ?? gstData?.tax ?? 0) : (gstData?.tax ?? 0),
            "totalAmount": isNoInvoiceReq ? (selectedInvObj?.totalInvoiceAmount ?? totalAmount ?? 0) : (totalAmount || 0),
            "uploadedDocumentList": docListPayload
        };

        apiClient.post(GENERATE_INVOICE, payload, {
            headers: {
                Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                "Content-Type": "application/json"
            }
        })
            .then((response) => {
                if (response.data?.isSuccess === true) {
                    toast.success(response.data.message);
                    setProceed(false);
                    if (!URN) {
                        navigate('/dashboardHome/sesList', {
                            state: {
                                tabValue: selectedMaterialtype,
                                pageName: 'generateInvoice'
                            }
                        });
                    } else {
                        navigate('/dashboardHome/invoiceList', {
                            state: {
                                tabValue: 'Pending',
                                materialTabValue: selectedMaterialtype
                            }
                        });
                    }
                }
                else if (response.data?.isSuccess === false) {
                    toast.error(response.data.message);
                }
                else {
                    toast.error("Error! Please try again");
                }
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };

    const onDeleteFile = (e, item) => {
        e.preventDefault();
        const rows = [...documentsArr];
        const index = rows.findIndex((doc) => doc === item);
        if (index !== -1) {
            rows.splice(index, 1);
            setDocumentsArr(rows);
        }
    };

    useEffect(() => {
        if (selectedFile) {
            getDocumentUploadDetails();
        }
    }, [selectedFile]);

    useEffect(() => {
        if (documentUploadDetails) {
            let tempARR = documentsArr ? [...documentsArr] : [];
            documentUploadDetails?.blobResponse && tempARR.push(documentUploadDetails?.blobResponse);
            setDocumentsArr(tempARR);
        }
    }, [documentUploadDetails]);

    const uploadDocument = (e) => {
        if (!e.target.files[0]) return;
        if (allowedFileTypes.indexOf(e.target.files[0].type) < 0) {
            return;
        }
        if (e.target.files[0].size >= 5000000) {
            setFileuploadError('The file should be less than 5MB');
            setSelectedFile();
        }
        else if (e.target.files[0].name.split('.').length > 2) {
            setFileuploadError("Double extension file detected");
            setSelectedFile();
        }
        else if (fileNameValidation(e.target.files[0].name)) {
            setFileuploadError(FILE_NAME_VALIDATION_ERROR);
            setSelectedFile();
        }
        else {
            setSelectedFile(e.target.files[0]);
            setFileuploadError('');
        }
    };

    function getDocumentUploadDetails() {
        loaderService.showLoader();
        const formData = new FormData();
        formData.append("file", selectedFile);
        formData.append("fileName", selectedFile.name);
        formData.append("containerName", "pit");
        apiClient
            .post(
                UPLOAD_DCUMENT,
                formData,
                {
                    headers: {
                        AuthKey: authKey,
                    },
                }
            )
            .then((response) => {
                setDocumentUploadDetails(response.data);
                loaderService.hideLoader();
            })

            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
            });
    }

    return (
        <>
            <Container maxWidth="xxl">
                {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT57</p>}
                <Card>
                    <CardContent>
                        <Grid container spacing={2}>
                            {!URN && <>
                                <Grid item xs={12} lg={4}>
                                    <FormControl fullWidth size="small" required={!!errorMessage.stakeholderType}>
                                        <InputLabel>Stakeholder Type</InputLabel>
                                        <Select label="Stakeholder Type" name="stakeholderType" value={details.stakeholderType || ''} onChange={(e) => handleChange(e, true)}>
                                            <MenuItem value="Transporter">Transporter</MenuItem>
                                            <MenuItem value="HIT">HIT</MenuItem>
                                        </Select>
                                        <FormHelperText sx={{ color: 'red' }}>{errorMessage.stakeholderType}</FormHelperText>
                                    </FormControl>
                                </Grid>
                                {details.stakeholderType === "HIT" &&
                                    <Grid item xs={12} lg={4}>
                                        <FormControl fullWidth size="small" required={!!errorMessage.serviceStakeholderType}>
                                            <InputLabel>Service Stakeholder Type</InputLabel>
                                            <Select label="Service Stakeholder Type" name="serviceStakeholderType" value={details.serviceStakeholderType || ''} onChange={(e) => handleChange(e, true)}>
                                                <MenuItem value="Harvester">Harvester</MenuItem>
                                                <MenuItem value="Transporter">Transporter</MenuItem>
                                            </Select>
                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.serviceStakeholderType}</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                }
                                <Grid item xs={12} lg={4}>
                                    <Autocomplete
                                        value={urnList.find((o) => o.urn === searchTerm) || null}
                                        getOptionLabel={(opt) => `${opt.urn} - ${opt.name}`}
                                        isOptionEqualToValue={(opt, val) => opt.urn === val.urn}
                                        onChange={(_, newValue) => {
                                            const urn = newValue?.urn ?? "";
                                            setSearchTerm(urn);
                                        }}
                                        options={urnList || []}
                                        renderInput={(params) => <TextField {...params} label="Stakeholder URN" variant="outlined" fullWidth size="small" />}
                                    />
                                </Grid>
                            </>
                            }
                            {details.stakeholderType === "Transporter" &&
                                <Grid item xs={12} lg={4}>
                                    <FormControl fullWidth size="small">
                                        <InputLabel id="routemapping-label">Route Mapping</InputLabel>
                                        <Select
                                            label="Route Mapping"
                                            name="transMappingRoute" value={details.transMappingRoute || ''} onChange={(e) => handleChange(e)}>
                                            <MenuItem value=""><em>Route</em></MenuItem>
                                            {
                                                routerDetails.map((transrouterdetails) =>
                                                    <MenuItem key={transrouterdetails} value={transrouterdetails}>{transrouterdetails}</MenuItem>)
                                            }
                                        </Select>
                                        <FormHelperText>{errorMessage?.chooseRouteError}</FormHelperText>
                                    </FormControl>
                                </Grid>
                            }
                            <Grid item xs={12} lg={4}>
                                <FormControl fullWidth size="small" required error={!!errorMessage.poNumber}>
                                    <InputLabel>PO Number</InputLabel>
                                    <Select label="PO Number" name="poNumber" value={details.poNumber} onChange={(e) => handleChange(e, true)}>
                                        {poList &&
                                            poList?.map((items) => (
                                                <MenuItem key={items} value={items}>{items}</MenuItem>
                                            ))}
                                    </Select>
                                    <FormHelperText sx={{ color: 'red' }}>{errorMessage.poNumber}</FormHelperText>
                                </FormControl>
                            </Grid>
                            {!URN && <Grid item xs={12} lg={4}>
                                <FormControl fullWidth required error={!!errorMessage.invoice}>
                                    <FormLabel>Invoice Generation Required?</FormLabel>
                                    <RadioGroup row>
                                        <FormControlLabel name="invoiceRequired" value="yes" checked={details.invoiceRequired === "yes"} onChange={(e) => handleChange(e, true)} control={<Radio />} label="Yes" />
                                        <FormControlLabel name="invoiceRequired" value="no" checked={details.invoiceRequired === "no"} onChange={(e) => handleChange(e, true)} control={<Radio />} label="No" />
                                    </RadioGroup>
                                    <FormHelperText sx={{ color: 'red' }}>{errorMessage.invoice}</FormHelperText>
                                </FormControl>
                            </Grid>}
                            {!URN && details?.invoiceRequired === "no" && <Grid item xs={12} lg={4} mt={details.stakeholderType === "Transporter" ? 2 : 0}>
                                <FormControl fullWidth size="small" required error={!!errorMessage.invoiceNumber}>
                                    <InputLabel>Invoice Number</InputLabel>
                                    <Select
                                        label="Invoice Number"
                                        name="invoiceNumber"
                                        value={details.invoiceNumber || ''}
                                        onChange={(e) => handleChange(e, true)}
                                    >
                                        {invoiceList &&
                                            invoiceList?.map((items, idx) => {
                                                const invoiceVal = typeof items === 'object' ? items.invoiceNumber : items;
                                                return (
                                                    <MenuItem key={invoiceVal || idx} value={invoiceVal}>
                                                        {invoiceVal}
                                                    </MenuItem>
                                                );
                                            })}
                                    </Select>
                                    <FormHelperText sx={{ color: 'red' }}>{errorMessage.invoiceNumber}</FormHelperText>
                                </FormControl>
                            </Grid>}

                            {(getLocalStorageItem('role') === PIT_ROLES?.PitScmUser && details.invoiceRequired !== "no") || URN ? (
                                <>
                                    <Grid item xs={12} lg={4}>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DesktopDatePicker
                                                label="From Date"
                                                inputFormat="DD/MM/YYYY"
                                                value={fromDate}
                                                onChange={(newValue) => {
                                                    setFromDate(newValue);
                                                    setProceed(false);
                                                }}
                                                renderInput={(params) => (
                                                    <TextField {...params} fullWidth size="small" />
                                                )}
                                            />
                                        </LocalizationProvider>
                                    </Grid>

                                    <Grid item xs={12} lg={4}>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DesktopDatePicker
                                                label="To Date"
                                                inputFormat="DD/MM/YYYY"
                                                value={toDate}
                                                onChange={(newValue) => {
                                                    setToDate(newValue);
                                                    setProceed(false);
                                                }}
                                                renderInput={(params) => (
                                                    <TextField {...params} fullWidth size="small" />
                                                )}
                                            />
                                        </LocalizationProvider>
                                    </Grid>
                                </>
                            ) : null}

                            {!URN && details?.invoiceRequired === "no" && selectedInvoiceGridData && selectedInvoiceGridData.length > 0 && (
                                <Grid item xs={12} sx={{ mt: 1, mb: 1 }}>
                                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1 }}>
                                        Invoice Details
                                    </Typography>
                                    <Box style={{ width: '100%' }}>
                                        <DataGrid
                                            autoHeight
                                            getRowHeight={() => 'auto'}
                                            rows={selectedInvoiceGridData}
                                            columns={invoiceDetailsColumns}
                                            getRowId={(row) => row.invoiceNumber}
                                            pageSize={5}
                                            rowsPerPageOptions={[5]}
                                            disableSelectionOnClick
                                            sx={{
                                                '& .MuiDataGrid-cell': {
                                                    py: 1,
                                                },
                                            }}
                                        />
                                    </Box>
                                </Grid>
                            )}


                            <Grid item xs={12} lg={3} mt={URN ? 0 : 2} ml={1}>
                                <Button variant="contained" onClick={onProceed}>Proceed</Button>
                            </Grid>

                            {proceed &&
                                <>
                                    <Grid item xs={12}>
                                        <Box style={{ height: 500, width: '100%' }}>
                                            <DataGrid
                                                rows={grnList}
                                                columns={grnColumns}
                                                checkboxSelection={!(details?.invoiceRequired === "no" && !URN)}
                                                pageSize={10}
                                                getRowId={(row) => row?.grnNo}
                                                selectionModel={selectionModel}
                                                onSelectionModelChange={(newSelectionModel) => {
                                                    setSelectionModel(newSelectionModel);
                                                    const selectedIDs = new Set(newSelectionModel);
                                                    const selectedRowData = grnList?.filter((row) =>
                                                        selectedIDs.has(row.grnNo.toString())
                                                    );
                                                    setSelectedRows(selectedRowData);
                                                    calculateTotalInvoice(selectedRowData);
                                                }}
                                                components={{
                                                    Toolbar: QuickSearchToolbar,
                                                }}
                                            />
                                        </Box>
                                    </Grid>

                                    {(URN || details?.invoiceRequired === "yes") && (
                                        <Grid item xs={12}>
                                            <Grid container spacing={2} sx={{ mt: 1 }}>
                                                <Grid item xs={12} md={6} lg={4}>
                                                    <TextField
                                                        fullWidth
                                                        disabled
                                                        size="small"
                                                        label="Total Delivered Qty"
                                                        value={totalDeliveredQty}
                                                        InputProps={{
                                                            readOnly: true,
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6} lg={4}>
                                                    <TextField
                                                        fullWidth
                                                        disabled
                                                        size="small"
                                                        label="Total Amount"
                                                        value={totalAmount}
                                                        InputProps={{
                                                            readOnly: true,
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    )}

                                    {(URN || details?.invoiceRequired === "yes") && <Grid item xs={12}>
                                        <FormControl fullWidth required error={!!errorMessage.invoice}>
                                            <FormLabel>Upload Invoice Number</FormLabel>
                                            <RadioGroup row>
                                                <FormControlLabel name="invoice" value="yes" checked={details.invoice === "yes"} onChange={(e) => handleChange(e, false)} control={<Radio />} label="Yes" />
                                                <FormControlLabel name="invoice" value="no" checked={details.invoice === "no"} onChange={(e) => handleChange(e, false)} control={<Radio />} label="No" />
                                            </RadioGroup>
                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.invoice}</FormHelperText>
                                        </FormControl>
                                    </Grid>}
                                    {(URN || details?.invoiceRequired === "yes") && details.invoice === "yes" &&
                                        <>
                                            <Grid item xs={12} lg={4} mt={1}>
                                                <TextField
                                                    fullWidth
                                                    required
                                                    error={!!errorMessage.invoiceNumber}
                                                    helperText={errorMessage.invoiceNumber}
                                                    label="Invoice Number"
                                                    onChange={(e) => handleChange(e, false)}
                                                    value={details?.invoiceNumber || ''}
                                                    name="invoiceNumber"
                                                    inputProps={{
                                                        maxLength: 16
                                                    }}
                                                />
                                            <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '1vh' }}>
                                                <Badge bg={`${details?.invoiceNumber?.length > characterLimit ? 'danger' : 'primary'}`}>{details?.invoiceNumber?.length}/{characterLimit}</Badge>
                                            </div>
                                            </Grid>
                                            <Grid item xs={12} lg={4} mt={1}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DesktopDatePicker
                                                        label="Invoice Date *"
                                                        inputFormat="DD/MM/YYYY"
                                                        value={details.invoiceDate}
                                                        onChange={(newValue) => {
                                                            setDetails({ ...details, invoiceDate: newValue });
                                                            setErrorMessage({ ...errorMessage, invoiceDate: "" });
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                fullWidth
                                                                error={!!errorMessage.invoiceDate}
                                                                helperText={errorMessage.invoiceDate}
                                                            />
                                                        )}
                                                    />
                                                </LocalizationProvider>
                                            </Grid>

                                            <Grid item xs={12} lg={8} mt={1}>
                                                <div>
                                                    <label className="view-file-link-common">
                                                        <input
                                                            style={{ display: "none" }}
                                                            type="file"
                                                            accept="image/jpeg, image/jpg, image/png, .pdf"
                                                            name="photo"
                                                            onChange={(e) => uploadDocument(e)}
                                                        />Upload File
                                                    </label>
                                                    {documentsArr?.map((item, index) => {
                                                        return (
                                                            <div key={index} style={{ display: "flex", flexDirection: "row", marginLeft: '1vh' }} className='view-file-name-common'>
                                                                {item?.fileName}
                                                                <img src={TrashIcon} style={{ cursor: "pointer", marginLeft: "2vh", height: "3vh" }} alt="TrashIcon" onClick={(e) => onDeleteFile(e, item)} />
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                                <Typography style={{ marginLeft: "3vh" }} variant="subtitle2" fontSize="1.8vh" align="left" color="green">{t('preReg.uploadFileTypeNote')}</Typography>
                                                <div className='resource-knowledge-error-message' >{fileuploadError}</div>
                                            </Grid>
                                        </>}
                                    <Grid item xs={12} lg={8} mt={1}>
                                        <TextField fullWidth
                                            error={!!errorMessage.comment}
                                            helperText={errorMessage.comment}
                                            multiline
                                            label="Comment"
                                            value={details.comment}
                                            onChange={(e) => { setDetails({ ...details, comment: VALIDATION.noSpecialCharacterValidation(capitalizeFunction(e.target.value)) }); setErrorMessage({ ...errorMessage, comment: "" }); }}
                                        />
                                    </Grid>
                                    {(URN || details?.invoiceRequired === "yes") && <Grid item xs={12} lg={12}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={isChecked}
                                                    disabled
                                                />
                                            }
                                            label="Generate Invoice"
                                        />
                                    </Grid>}
                                    <Grid item xs={12} mt={2}>
                                        <Button variant="contained" onClick={onCreateInvoice} style={{ float: "right" }}>{!URN ? "Generate SES" : "Submit"}</Button>
                                    </Grid>
                                </>}
                        </Grid>
                    </CardContent>
                </Card>
            </Container>
            <ConfirmationPopover onOpen={logModalOpen} onConfirm={onConfirmSubmit} onClose={handleLogModalClose} action="Submit" />
        </>
    );
}

export default GenerateInvoice;
